import styled from 'styled-components';

export const Cart = styled.div`
  height: 31px;
  border: 1px solid rgba(52, 242, 200, 0.6);

  display: flex;
  align-items: center;

  padding: 0 14px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const CartContainer = styled.div`
  width: 23px;
  height: 21px;

  position: relative;
  z-index: 1;

  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: -5px;
    bottom: -5px;
    left: -5px;
    right: -5px;
    > .bg-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

export const MessageBlock = styled.div`
  position: absolute;

  top: 0;
  right: 0;
  transform: translateX(100%);

  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  background: rgba(228, 44, 45, 1);
  border-radius: 50%;

  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
`;

export const Title = styled.div`
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(52, 242, 200, 1);
  margin-left: 25px;
`;
